import React from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LEVEL_ADMIN } from "../../../utils/userPermissions";
import { usePermissions } from "../../../context/permissionsContext";
import PaginationButtons from "../../shared/components/PaginationButtons";

function MembersStats({
  error,
  statsRef,
  formData,
  paginationData,
  searchQuery,
  onInputChange,
  onQuerySubmit,
  onClearFilter,
  onPageChange,
  setShowDateFilterModal,
}) {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const userEarning = (id, name) => {
    navigate(`/affiliate-program/income-history?id=${id}&name=${name}`);
  };

  return (
    <>
      <div className="col-lg-11 col-12 px-lg-0 px-4">
        <div className="d-space-between px-4">
          <div className="d-start">
            {searchQuery && (
              <span
                onClick={onClearFilter}
                className="mr-2 border border-1 text-sm rounded-pill bg-gradient-gray text-white px-2 py-1 cursor-pointer shortcut-media"
                role="button"
                tabIndex={0}
                aria-label="Clear filter"
              >
                Clear Filter &times;
              </span>
            )}
            <div
              id="datatable-basic_filter"
              className="dataTables_filter pr-0 pt-3"
            >
              <form
                className="leaderboard-grid-search"
                onSubmit={onQuerySubmit}
              >
                <div className="input-group mb-3">
                  <input
                    required
                    type="text"
                    disabled={formData?.affiliated_users?.data?.length === 0}
                    style={{ height: "31px" }}
                    className="form-control"
                    placeholder="Search..."
                    aria-label="Search users"
                    value={searchQuery}
                    onChange={onInputChange}
                  />
                  <div
                    style={{ height: "31px" }}
                    className="input-group-append"
                  >
                    <button
                      type="submit"
                      id="button-addon2"
                      style={{ padding: "0px 15px" }}
                      className="btn btn-outline-primary"
                      disabled={
                        formData?.affiliated_users?.data?.length === 0 ||
                        searchQuery === ""
                      }
                      aria-label="Search"
                    >
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="d-end">
            <button
              className="btn btn-light-outlined border p-2"
              onClick={() => setShowDateFilterModal(true)}
            >
              <span className="date-icon">
                <i className="fa fa-calendar text-dark text-xs"></i>
              </span>
              <span className="text-xs">Date Range</span>
            </button>
          </div>
        </div>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <div className="table-responsive rounded-top">
          <table
            className="table"
            style={{ backgroundColor: "#f7f7f7" }}
            ref={statsRef}
          >
            <thead className="bg-default text-white">
              <tr>
                {hasPermission(LEVEL_ADMIN) && (
                  <th className="border-top-0">Affiliate Name</th>
                )}
                <th className="border-top-0">Name</th>
                <th className="border-top-0">Joining Date</th>
                <th className="border-top-0">Level</th>
                <th className="border-top-0">Amount</th>
                <th className="border-top-0">Status</th>
                <th className="border-top-0">Subscription Status</th>
                <th className="border-top-0">Next Invoice Date</th>
              </tr>
            </thead>
            <tbody>
              {formData?.affiliated_users?.data?.length > 0 ? (
                formData?.affiliated_users?.data?.map((user, index) => (
                  <tr key={index}>
                    {hasPermission(LEVEL_ADMIN) && (
                      <td>
                        <Tooltip arrow placement="right" title="Visit Profile">
                          <span className="text-capitalize">
                            <a
                              className="text-default"
                              href={`/profile/${user?.affiliate_uuid}`}
                            >
                              {" "}
                              {user.affiliate_name}
                            </a>
                          </span>
                        </Tooltip>
                      </td>
                    )}
                    <td>
                      <Tooltip arrow placement="right" title="Visit Profile">
                        <span className="text-capitalize">
                          <a
                            className="text-default"
                            href={`/profile/${user?.uuid}`}
                          >
                            {user.name}
                          </a>
                        </span>
                      </Tooltip>
                    </td>
                    <td>{user.joining_date}</td>
                    <td>
                      <span className="d-start badge badge-dot mr-4">
                        <i className="bg-success"></i>
                        {user.level}
                      </span>
                    </td>
                    <td>$ {user.earning}</td>
                    <td>
                      <Tooltip
                        arrow
                        placement="left"
                        title="View Income History"
                      >
                        <span
                          className="text-default cursor-pointer"
                          onClick={() =>
                            hasPermission(LEVEL_ADMIN) &&
                            userEarning(user.affiliate_id, user.affiliate_name)
                          }
                          style={{
                            backgroundColor:
                              user?.status === "Payout Received"
                                ? "#15A30933"
                                : user?.status === "Payout In Review"
                                ? "#FFD70033"
                                : user?.status === "Subscription Pending"
                                ? "#C6070733"
                                : "inherit",
                            padding: "3px 8px",
                            borderRadius: "15px",
                          }}
                        >
                          {user?.status}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      {user?.subscription_status ? (
                        <span
                          style={{
                            backgroundColor:
                              user?.subscription_status === "Active" ||
                              user?.subscription_status === "ACTIVE"
                                ? "#15A30933" // Green background for Active
                                : user?.subscription_status === "Grace Period" ||
                                  user?.subscription_status === "GRACE_PERIOD"
                                ? "#ADD8E6" // Light blue background for Grace Period
                                : user?.subscription_status === "Inactive" ||
                                  user?.subscription_status === "INACTIVE"
                                ? "#FFCDD2" // Light red background for Inactive
                                : "#FFD70033", // Yellow for other statuses
                            color:
                              user?.subscription_status === "Active" ||
                              user?.subscription_status === "ACTIVE"
                                ? "#15A309" // Green text for Active
                                : user?.subscription_status === "Grace Period" ||
                                  user?.subscription_status === "GRACE_PERIOD"
                                ? "#0066CC" // Blue text for Grace Period
                                : user?.subscription_status === "Inactive" ||
                                  user?.subscription_status === "INACTIVE"
                                ? "#C60707" // Red text for Inactive
                                : "inherit",
                            padding: "3px 8px",
                            borderRadius: "15px",
                            fontWeight: "500",
                          }}
                        >
                          {user.subscription_status}
                        </span>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </td>
                    <td>
                      {user?.next_invoice_date ? (
                        user.next_invoice_date
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      hasPermission(LEVEL_ADMIN) ? "8" : "7"
                    }
                    style={{ textAlign: "center" }}
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="pagination-container text-center pb-2">
            <span>
              Showing {paginationData.from || 0} to {paginationData.to || 0} of{" "}
              {paginationData.total || 0} entries
            </span>
            <span className="d-center">
              {paginationData.links?.length > 3 && (
                <PaginationButtons
                  paginationData={paginationData}
                  onPageChange={onPageChange}
                />
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(MembersStats);
